import { Event } from '../Event'
import { ViewerContext } from '../../constants'

export interface ExpertLeadEscalationNotificationFilteredEventProperties {
  lead_escalation_id: string
  occurred_at: string
  filtered_at: string
}

export class ExpertLeadEscalationNotificationFilteredEvent extends Event<
  ExpertLeadEscalationNotificationFilteredEventProperties
> {
  static displayName = 'Expert Lead Escalation Notification Filtered'

  static allowedViewerContexts = [ViewerContext.BusinessUser]
}
